import { css } from "lit";
export default css `
    footer {
        padding: var(--footer-padding);
        width: 100vw;
        font-size: var(--footer-font-size);
        height: var(--footer-height);
        position: fixed;
        bottom: 0;
        background-color: var(--background-color);
        z-index: 10;
        border-top: 1px dashed var(--secondary-color);
    }

    footer > .generated-timestamp {
        float: right;
        margin-right: 15px;
        font-weight: normal;
        color: var(--font-color-sub2);
    }
`;
